import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

export default {
  namespaced: true,
  state() {
    return {
      // this will be populated when admin logs into the app
      products: [],
      quickEditActive: false,
    };
  },
  mutations,
  getters,
  actions,
};
